import { Expression } from 'mapbox-gl';

export const strikeLayer = {
    type: 'symbol' as const,
    layout: {
        'icon-image': [
            'match',
            ['get', 'strike_type'],
            'GROUND',
            ['case', ['>=', ['get', 'kA'], 0], 'cloud-ground-positive', ['<', ['get', 'kA'], 0], 'cloud-ground-negative', ''],
            'CLOUD',
            'cloud-cloud',
            '',
        ] as Expression,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'symbol-z-order': 'source' as const,
    },
};

export const circleLayer = {
    type: 'fill' as const,
    paint: {
        'fill-color': [
            'case',
            ['==', ['get', 'status'], 2],
            'rgb(250, 97, 97)',
            ['==', ['get', 'status'], 1],
            'rgb(223, 123, 1)',
            'rgb(116, 163, 15)',
        ] as Expression,
        'fill-opacity': 0.5,
        'fill-outline-color': 'rgba(0, 0, 0, 0)',
    },
};

export const circleOutlineLayer = {
    type: 'line' as const,
    paint: {
        'line-dasharray': [0, 2],
        'line-width': 2,
    },
    layout: {
        'line-cap': 'round' as const,
    },
};

export const circleOutlineNoRiskLayer = {
    type: 'line' as const,
    paint: {
        'line-dasharray': [0, 2],
        'line-width': 2,
    },
    layout: {
        'line-cap': 'round' as const,
    },
};

export const circleOutlineWarningLayer = {
    type: 'line' as const,
    paint: {
        'line-dasharray': [4, 6],
        'line-width': 2,
    },
    layout: {
        'line-cap': 'round' as const,
    },
};

export const circleOutlineAlertLayer = {
    type: 'line' as const,
    paint: {
        'line-width': 2,
    },
};
